import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useAppSelector } from '../../redux/hooks'
import { RootState } from '../../redux/store'
import { TLevel, TUserProfile } from '@smartico/public-api/dist/WSAPI/WSAPITypes'
import ProgressMark from '../../img/svgComponents/ProgressMark'
import { Link, useLocation } from 'react-router-dom'

const LevelsScale = () => {
	const location = useLocation()
	const levels = useAppSelector((state: RootState) => state.level.levels)
	const profile = useAppSelector((state: RootState) => state.userPublic.profile)
	const [progressLevel, setProgressLevel] = useState<TLevel>()
	const [isFinalLevel, setIsFinalLevel] = useState<boolean>(false)
	const progressBarRef = useRef<HTMLDivElement>(null)
	const [width, setWidth] = useState<number>(0)
	const [currentLevel, setCurrentLevel] = useState<TLevel>()

	useEffect(() => {
		if (profile && levels) {
			setCurrentLevel(levels.find((level: TLevel) => level.id === profile.ach_level_current_id))
		}
	}, [profile, levels])

	useEffect(() => {
		if (levels && profile) {
			getProgressLevel(levels, profile)
		}

		if (progressBarRef.current) {
			const elementWidth = progressBarRef.current.getBoundingClientRect().width
			setWidth(elementWidth)
		}
	}, [levels, profile])

	const getProgressLevel = (allLevels: TLevel[], userInfo: TUserProfile) => {
		const currentLevelIndex = allLevels.findIndex((lvl) => lvl.id === userInfo.ach_level_current_id)
		if (currentLevelIndex !== -1) {
			if (currentLevelIndex < allLevels.length - 1) {
				const nextLevel = allLevels[currentLevelIndex + 1]
				setProgressLevel(nextLevel)
			} else {
				setIsFinalLevel(true)
			}
		}
	}

	const progressPercentage = useMemo(() => {
		if (currentLevel && progressLevel && profile) {
			const currentPoints = profile.ach_points_ever
			const levelStart = currentLevel.required_points
			const levelEnd = progressLevel.required_points
			const range = levelEnd - levelStart
			if (range <= 0) return 0
			return Math.min(((currentPoints - levelStart) / range) * 100, 100)
		}
		return 0
	}, [currentLevel, progressLevel, profile])

	const pointsLeft = useMemo(() => {
		if (profile && progressLevel) {
			const pointsNeeded = progressLevel.required_points ?? 0
			const currentPoints = profile.ach_points_ever ?? 0
			return Math.max(pointsNeeded - currentPoints, 0)
		}
		return null
	}, [profile, progressLevel])
	return (
		<div className="levels-scale">
			<div className="progress-bar-container">
				<Link to="/vip" style={{ display: 'block', textDecoration: 'none', zIndex: '2' }}>
					<div className={`progress-level-icon ${location.pathname === '/vip' ? '' : 'start'}`}>
						<img src={currentLevel?.image} alt="Start Level" />
						<div>{currentLevel?.name}</div>
					</div>
				</Link>
				<div ref={progressBarRef} className="progress-bar">
					{Array(Math.round(width / 15))
						.fill(null)
						.map((_, i) => (
							<ProgressMark />
						))}
					<div className="progress-fill" style={{ width: `${isFinalLevel ? 100 : progressPercentage}%` }}></div>
				</div>
				<Link to="/vip" className={`progress-level-icon ${location.pathname === '/vip' ? 'end-lvl' : 'end'}`}>
					<img src={isFinalLevel ? currentLevel?.image : progressLevel?.image} alt="Next Level" />
					<div className="tasks-left">{isFinalLevel ? 'Max Level' : pointsLeft !== null ? `${pointsLeft} pts left` : ''}</div>
				</Link>
			</div>
		</div>
	)
}

export default LevelsScale
